import React from "react";
import createAnalysisChart from "./CreateAnalysisChart";
import { INDUSTRY_COLOR_MAP } from "../../../lib/constants";
import { AnalysisChartProps } from "./types";

const IndustryAnalysisChart = createAnalysisChart({
  chartType: "industry",
  title: "Industries Analysis",
  legendTitle: "Industries",
  categoryField: "Industry",
  colorMap: INDUSTRY_COLOR_MAP,
  volumeLabel: "Invested capital",
  countLabel: "Number of deals",
}) as React.ComponentType<AnalysisChartProps>;

export default IndustryAnalysisChart;
